import React from "react";
import { connect } from "react-redux";
import swal from "sweetalert";
import DynamicTabwiseTable from "../../../components/dynamicscreens/DynamicTabwiseTable";
import endpoint from "../../../config/endpoints";
import {
  FailTogenerateCredentialMsg,
  beatsAssign,
  changeActive,
  generateCredentialMsg,
  noInternetMsg,
  saveFailedMsg,
  sendCredentialMsg,
  serverMsg,
  statusmsg,
} from "../../../config/messageconstant";

import { getDriversByArea } from "../../../Slice/salesExecutive.slice";
import { driverColumns } from "../../../tableColumns/table-columns";
import { apiGet, apiPost } from "../../../utils/api_service";
import { showLoador, showNotification } from "../../Landing/Landing.slice";
import { downloadF } from "../../PDF/PDFDownload";
import { compose } from "recompose";
import { withRouter } from "../../../components/withRouter";
import { DriverJson } from "../../../DynamicFormsJson/MastersJSON/driverJson";

class DriverTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tabValue: 1,
      moduleObjDataObj: {},
      isLog: true,
      dynamicMasterData: {
        SalesExecutiveListInActive:
          this.props.salesExecutiveList?.salesExecutive.filter(
            (row) => row.isActive == 0
          ),
        SalesExecutiveListActive:
          this.props.salesExecutiveList?.salesExecutive.filter(
            (row) => row.isActive == 1
          ),
      },
      tabList: [
        {
          label: "Active",
          allyProps: 0,
          columns: driverColumns,
          showExcelDownload: true,
          changeExcelURL: "sales-executive-data",
          isActionColActive: true,
          value: "SalesExecutiveListActive",
        },
        {
          label: "InActive",
          allyProps: 1,
          columns: driverColumns,
          showExcelDownload: true,
          changeExcelURL: "sales-executive-data",
          isActionColActive: true,
          value: "SalesExecutiveListInActive",
        },
      ],
    };
  }
  componentDidMount() {
    const moduleObjData = localStorage.getItem("moduleObj");
    const moduleObjDataObj =
      moduleObjData != null ? JSON.parse(moduleObjData) : {};

    if (
      localStorage.getItem("showFilterDataWiseExcel") &&
      localStorage.getItem("showFilterDataWiseExcel") == 1
    ) {
      this.setState((prevState) => ({
        tabList: prevState.tabList.map((tab) => ({
          ...tab,
          showExcelDownload: false,
        })),
      }));
    }

    this.setState({ moduleObjDataObj });

    this.getListData();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.stockStakeHolderType !== nextProps.stockStakeHolderType) {
      if (
        this.props.stockStakeHolderType?.stockStakeHolderType !==
        nextProps.stockStakeHolderType?.stockStakeHolderType
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            stockStakeHolderTypeDetail:
              nextProps.stockStakeHolderType?.stockStakeHolderType,
          },
        });
      }
    }
    if (this.props.salesExecutiveList !== nextProps.salesExecutiveList) {
      if (
        this.props.salesExecutiveList?.salesExecutive !==
        nextProps.salesExecutiveList?.salesExecutive
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            SalesExecutiveListActive:
              nextProps.salesExecutiveList?.salesExecutive
                .filter((row) => row.isActive == 1)
                .map((rowData, index) => {
                  return { ...rowData, index: index + 1 };
                }),
            SalesExecutiveListInActive:
              nextProps.salesExecutiveList?.salesExecutive
                .filter((row) => row.isActive == 0)
                .map((rowData, index) => {
                  return { ...rowData, index: index + 1 };
                }),
          },
        });
      }
    }
  }
  generateStaticExcelMethod = () => {
    const { showLoador, showNotification } = this.props;
    showLoador({ loador: true });
    downloadF({
      url: endpoint.exportData + "/get-drivers-data",
      ext: "xls",
      openNewTab: true,
    }).then((response) => {
      showLoador({ loador: false });
      if (!response) {
        showNotification({
          msg: serverMsg,
          severity: "error",
        });
      }
    });
  };

  onClickApplySend = (rowData) => {
    const { moduleObjDataObj, isLog } = this.state;

    swal({
      title: "Are you sure?",
      text: sendCredentialMsg,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        if (navigator.onLine) {
          this.props.showLoador({ loador: true });
          apiGet({
            url: endpoint.salesExecutive + "/" + rowData.id + "/password-reset",
          }).then(({ success }) => {
            if (success) {
              if (isLog) {
                if (rowData !== null) {
                  let updatedJsonToSend = JSON.stringify(rowData);

                  let dataToSaveForMLog = {
                    module: {
                      moduleId: moduleObjDataObj.moduleId,
                    },
                    subModule: {
                      subModuleId: moduleObjDataObj.subModuleId,
                    },
                    operationType: 1,
                    type: 1,
                    operationPerformId: rowData.id,
                    updatedJson: updatedJsonToSend,
                  };

                  showLoador({ loador: true });
                  apiPost({
                    url: endpoint.mlog,
                    postBody: dataToSaveForMLog,
                  }).then(({ success }) => {
                    showLoador({ loador: false });
                    if (success) {
                    } else {
                      showNotification({
                        msg: saveFailedMsg,
                        severity: "error",
                      });
                    }
                  });
                }
              }

              this.props.showLoador({ loador: false });
              this.props.showNotification({
                msg: generateCredentialMsg,
              });
            } else {
              this.props.showNotification({
                msg: FailTogenerateCredentialMsg,
                severity: "error",
              });
              this.props.showLoador({ loador: false });
            }
          });
        } else {
          this.props.showNotification({
            msg: noInternetMsg,
            severity: "error",
          });
        }
      }
    });
  };
  getTabValue = (rowValue) => {
    this.setState({
      tabValue: rowValue == 0 ? 1 : 0,
    });
  };
  getListData = async () => {
    const { getDriversByArea, showLoador, showNotification } = this.props;
    if (navigator.onLine) {
      showLoador({ loador: true });
      await getDriversByArea({
        userTypeId: 4,
      }).then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  onChangeStatus = (rowData) => {
    const { showLoador, showNotification } = this.props;
    const { moduleObjDataObj, isLog } = this.state;
    if (navigator.onLine) {
      let status = rowData.isActive == 1 ? 0 : 1;

      showLoador({ loador: true });
      apiGet({
        url: endpoint.assignBeat + "/by-sales-team?salesTeamId=" + rowData.id,
      }).then(({ data, success }) => {
        if (!success || data.error) {
          showLoador({ loador: false });
          showNotification({ msg: serverMsg, severity: "error" });
        } else {
          showLoador({ loador: false });
          if (data && data.data && data.data.length !== 0) {
            showNotification({ msg: beatsAssign, severity: "error" });
          } else {
            swal({
              text: changeActive,
              icon: "warning",
              buttons: true,
              dangerMode: true,
            }).then((willDelete) => {
              if (willDelete) {
                showLoador({ loador: true });
                apiPost({
                  url:
                    endpoint.salesExecutive +
                    "/update-is-active/?id=" +
                    rowData.id +
                    "&status=" +
                    status,
                }).then(({ data, success }) => {
                  if (success) {
                    if (isLog) {
                      if (rowData !== null) {
                        let updatedJsonToSend = JSON.stringify(rowData);

                        let dataToSaveForMLog = {
                          module: {
                            moduleId: moduleObjDataObj.moduleId,
                          },
                          subModule: {
                            subModuleId: moduleObjDataObj.subModuleId,
                          },
                          operationType: 1,
                          type: 1,
                          operationPerformId: rowData.id,
                          updatedJson: updatedJsonToSend,
                        };

                        showLoador({ loador: true });
                        apiPost({
                          url: endpoint.mlog,
                          postBody: dataToSaveForMLog,
                        }).then(({ success }) => {
                          showLoador({ loador: false });
                          if (success) {
                          } else {
                            showNotification({
                              msg: saveFailedMsg,
                              severity: "error",
                            });
                          }
                        });
                      }
                    }

                    showLoador({ loador: false });
                    showNotification({ msg: statusmsg });
                    this.getListData();
                  } else {
                    showLoador({ loador: false });
                    showNotification({ msg: serverMsg, severity: "error" });
                  }
                });
              }
            });
          }
        }
      });
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };


  render() {
    const { salesExecutiveList } = this.props;
    const { dynamicMasterData, tabList } = this.state;
    const isShowSendCredentialIcon =
      localStorage.getItem("isShowSendCredentialIcon") !== null ? localStorage.getItem("isShowSendCredentialIcon") : 1;
    return (
      <>
        <DynamicTabwiseTable
          dynamicMasterData={dynamicMasterData}
          searchList={DriverJson.searchList}
          formPath={DriverJson.formPath}
          screenTitle={DriverJson.screenTitle}
          fieldMeta={DriverJson.fieldMeta}
          showPdfDownload={DriverJson.showPdfDownload}
          showExcelDownload={true}
          isExcelStaticUrl={true}
          showView={true}
          formPathView={DriverJson.formPathView}
          filterDataExcel={true}
          pdfFileName={DriverJson.pdfFileName}
          excelFileName={DriverJson.excelFileName}
          showAddButton={DriverJson.showAddButton}
          tableColumnsToFilter={DriverJson.tableColumnsToFilter}
          tableColumns={driverColumns}
          tableData={salesExecutiveList?.salesExecutive}
          apiBaseURL={DriverJson.apiBaseURL}
          callApi={false}
          isActiveURL={DriverJson.isActiveURL}
          showAddButtonInTable={true}
          onClickAdd={this.onClickAdd}
          openFormPath={DriverJson.openFormPath}
          searchButtonGrid={DriverJson.searchButtonGrid}
          getTableDataById={true}
          onSearchData={this.getListData}
          showApplyCredintial={isShowSendCredentialIcon == 1 ? true : false}
          rowStatusTrue={true}
          rowStatus={this.onChangeStatus}
          rowApply={this.onClickApplySend}
          tabList={tabList}
          generateStaticExcelMethod={this.generateStaticExcelMethod}
          changeExcelURL={
            "excel-report-for-sale-executive?stockStakeHolderTypeIds=4"
          }
          isNote={true}
          isNoteValue={"Add Driver Details"}
          rowList={dynamicMasterData}
          formPathStatic={false}
          showHeadEdit={true}
          staticEdit={false}
          deleteStaticTrue={false}
          deleteMsgAuto={true}
          getTabValue={this.getTabValue}
          showHeadDelete={true}
          showPegination={true}
        />
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  salesExecutiveList: state.salesExecutive,
  stockStakeHolderType: state.stockStakeHolderType,
});
const mapDispatchToProps = {
  getDriversByArea,
  showLoador,
  showNotification,
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(DriverTable);
